// import React, { useState } from "react";
// import "./index.css"; // You can add your custom styles here

// const Modal = ({ isOpen, onClose, product }) => {
//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false)
//   const [customerName, setCustomerName] = useState("");
//   const [customerMobile, setCustomerMobile] = useState("");
//   const [customerEmail, setCustomerEmail] = useState("");
//   const [whatsappNumber, setWhatsappNumber] = useState("");


//   const openWhatsappModal = () => {
//     // setIsWhatsappModalOpen(true);
//     alert('Current this option not available . Please use email option to pass referral')
//   };


//   const handleWhatsappSubmit = () => {
//     // Construct the message text
//     const message = `Check out this product: ${product.productName}. Price: ${product.productPrice}. Offer: ${product.offer}% off. Validity: ${product.validity || 'N/A'}.`;
  
//     // Ensure the image URL is valid and can be shared
//     const productImage = encodeURIComponent(product.productPhoto);
  
//     // Create the WhatsApp message link with image URL
//     const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}%0A%0A${productImage}`;
  
//     // Open the link in a new tab (WhatsApp)
//     window.open(whatsappLink, '_blank');
  
//     alert("Referral sent successfully via WhatsApp!");
//     closeWhatsappModal(); // Close the WhatsApp modal
//   };
  
//   // Function to close the WhatsApp modal
//   const closeWhatsappModal = () => {
//     setIsWhatsappModalOpen(false);
//   };

//   const [step, setStep] = useState(1); // Track which step we're on
//   const [sending, setSending] = useState(false);
//   const [error, setError] = useState(null);

//   if (!isOpen) return null;

//   // Function to open the email modal
//   const openEmailModal = () => {
//     setIsEmailModalOpen(true);
//   };

//   // Function to close the email modal
//   const closeEmailModal = () => {
//     setIsEmailModalOpen(false);
//   };

//   const handleEmailSubmit = async () => {
//     setSending(true); // Show sending state
//     setError(null); // Reset any previous error

//     const referralData = {
//       product: product.productPhoto, // Send product image URL
//       price: product.productPrice,
//       name: product.productName,
//       customerEmail: customerEmail,
//       salerEmail: product.UserId, // Assuming this is available in product
//       customerName: customerName,
//       customerMobile: customerMobile,
//     };

//     try {
//       // Make the POST request to your API
//       const response = await fetch(
//         "https://api.lbnhyderabad.com/product/product-referral",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(referralData),
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         alert("Referral sent successfully!");
//         closeEmailModal(); // Close modal on success
//       } else {
//         throw new Error(result.message || "Something went wrong");
//       }
//     } catch (error) {
//       setError(error.message); // Set error state if API call fails
//     } finally {
//       setSending(false); // Reset sending state
//     }
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "Not Given"; // If no date, return "Not Given"

//     let date = new Date(dateStr);
//     if (date.toString() === "Invalid Date") return "Not Given"; // Check if the date is invalid

//     let day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
//     let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
//     let year = date.getFullYear();

//     return `${day}-${month}-${year}`; // Format in dd-mm-yyyy
//   };

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className="modal-content"
//         style={{ backgroundColor: "white" }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="modal-header">
//           <h2>Product Details</h2>
//           <button className="close-btnn" onClick={onClose}>
//             X
//           </button>
//         </div>
//         <div className="modal-body">
//           <div className="modal-left">
//             <img
//               src={product.productPhoto}
//               alt={product.productName}
//               className="image-height"
//             />
//           </div>
//           <div className="modal-right">
//             <h3 style={{ color: "#4c51bf" }}>{product.productName}</h3>
//             <p>{product.productDesc || "No description available"}</p>
//             <p>
//               <strong>Price:</strong> {product.productPrice}
//             </p>
//             <p>
//               <strong>Offer:</strong>{" "}
//               {product.offer ? `${product.offer}%` : "No offer available"}
//             </p>
//             <p>
//               <strong>Validity:</strong> {formatDate(product.validity) || "N/A"}
//             </p>
//             <p><strong>GST Verified ✅</strong></p>
//             <p><strong>KYC Verified( Aadhaar ) ✅</strong></p>

//             <h4>Referral</h4>
//             <div className="referral-buttons">
//               <button
//                 className="referral-btn email-btn"
//                 onClick={openEmailModal}
//               >
//                 Email
//               </button>
             
//                 <button className="referral-btn whatsapp-btn" 
//                 onClick={openWhatsappModal}
//                 >WhatsApp</button>
         
//             </div>
//           </div>
//         </div>
//       </div>

//       {isEmailModalOpen && (
//         <div className="modal-overlayy" onClick={closeEmailModal}>
//           <div
//             className="modal-contentt"
//             style={{ backgroundColor: "white" }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-headerr">
//               <h2>Enter Customer Details</h2>
//               <button className="close-btn" onClick={closeEmailModal}>
//                 X
//               </button>
//             </div>
//             <div className="modal-bodyy">
//               <label>
//                 Customer Name:
//                 <input
//                   type="text"
//                   value={customerName}
//                   onChange={(e) => setCustomerName(e.target.value)}
//                 />
//               </label>
//               <label>
//                 Customer Mobile:
//                 <input
//                   type="text"
//                   value={customerMobile}
//                   onChange={(e) => setCustomerMobile(e.target.value)}
//                 />
//               </label>
//               <label>
//                 Customer Email:
//                 <input
//                   type="email"
//                   value={customerEmail}
//                   onChange={(e) => setCustomerEmail(e.target.value)}
//                 />
//               </label>

//               <div className="modal-footer">
//                 <button className="cancel-btn" onClick={closeEmailModal}>
//                   Cancel
//                 </button>
//                 <button className="send-btn" onClick={handleEmailSubmit}>
//                   Send
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

// {isWhatsappModalOpen && (
//         <div className="modal-overlayy" onClick={closeWhatsappModal}>
//           <div
//             className="modal-contentt"
//             style={{ backgroundColor: "white" }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-headerr">
//               <h2>Enter WhatsApp Number</h2>
//               <button className="close-btn" onClick={closeWhatsappModal}>
//                 X
//               </button>
//             </div>
//             <div className="modal-bodyy">
//               <label>
//                 WhatsApp Number:
//                 <input
//                   type="text"
//                   value={whatsappNumber}
//                   onChange={(e) => setWhatsappNumber(e.target.value)}
//                   placeholder="Enter WhatsApp Number"
//                 />
//               </label>

//               <div className="modal-footer">
//                 <button className="cancel-btn" onClick={closeWhatsappModal}>
//                   Cancel
//                 </button>
//                 <button className="send-btn" onClick={handleWhatsappSubmit}>
//                   Send
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Modal;


import React, { useState } from "react";
import "./index.css"; // You can add your custom styles here

const Modal = ({ isOpen, onClose, product }) => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false)
  const [customerName, setCustomerName] = useState("");
    const [customerWName, setCustomerWName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");


  const openWhatsappModal = () => {
    setIsWhatsappModalOpen(true);
  
  };


  const handleWhatsappSubmit =async () => {
    // Construct the message text

    const referralData = {
 
      name: product.productName,
      salerEmail: product.UserId, // Assuming this is available in product
      customerName: customerWName,
      customerMobile: whatsappNumber,
    };

    try {
      // Make the POST request to your API
      const response = await fetch(
        "https://api.lbnhyderabad.com/product/product-referral-whatsapp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(referralData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Referral sent successfully!");
        closeEmailModal(); // Close modal on success
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (error) {
      setError(error.message); // Set error state if API call fails
    } finally {
      setSending(false); // Reset sending state
    }
  
    alert("Referral sent successfully via WhatsApp!");
    closeWhatsappModal(); // Close the WhatsApp modal
  };
  
  // Function to close the WhatsApp modal
  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
  };

  const [step, setStep] = useState(1); // Track which step we're on
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  // Function to open the email modal
  const openEmailModal = () => {
    setIsEmailModalOpen(true);
  };

  // Function to close the email modal
  const closeEmailModal = () => {
    setIsEmailModalOpen(false);
  };

  const handleEmailSubmit = async () => {
    setSending(true); // Show sending state
    setError(null); // Reset any previous error

    const referralData = {
      product: product.productPhoto, // Send product image URL
      price: product.productPrice,
      name: product.productName,
      customerEmail: customerEmail,
      salerEmail: product.UserId, // Assuming this is available in product
      customerName: customerName,
      customerMobile: customerMobile,
    };

    try {
      // Make the POST request to your API
      const response = await fetch(
        "https://api.lbnhyderabad.com/product/product-referral",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(referralData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Referral sent successfully!");
        closeEmailModal(); // Close modal on success
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (error) {
      setError(error.message); // Set error state if API call fails
    } finally {
      setSending(false); // Reset sending state
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "Not Given"; // If no date, return "Not Given"

    let date = new Date(dateStr);
    if (date.toString() === "Invalid Date") return "Not Given"; // Check if the date is invalid

    let day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    let year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format in dd-mm-yyyy
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        style={{ backgroundColor: "white" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Product Details</h2>
          <button className="close-btnn" onClick={onClose}>
            X
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-left">
            <img
              src={product.productPhoto}
              alt={product.productName}
              className="image-height"
            />
          </div>
          <div className="modal-right">
            <h3 style={{ color: "#4c51bf" }}>{product.productName}</h3>
            <p>{product.productDesc || "No description available"}</p>
            <p>
              <strong>Price:</strong> {product.productPrice}
            </p>
            <p>
              <strong>Offer:</strong>{" "}
              {product.offer ? `${product.offer}%` : "No offer available"}
            </p>
            <p>
              <strong>Validity:</strong> {formatDate(product.validity) || "N/A"}
            </p>
            <p><strong>GST Verified ✅</strong></p>
            <p><strong>KYC Verified( Aadhaar ) ✅</strong></p>

            <h4>Referral</h4>
            <div className="referral-buttons">
              <button
                className="referral-btn email-btn"
                onClick={openEmailModal}
              >
                Email
              </button>
             
                <button className="referral-btn whatsapp-btn" 
                onClick={openWhatsappModal}
                >WhatsApp</button>
         
            </div>
          </div>
        </div>
      </div>

      {isEmailModalOpen && (
        <div className="modal-overlayy" onClick={closeEmailModal}>
          <div
            className="modal-contentt"
            style={{ backgroundColor: "white" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-headerr">
              <h2>Enter Customer Details</h2>
              <button className="close-btn" onClick={closeEmailModal}>
                X
              </button>
            </div>
            <div className="modal-bodyy">
              <label>
                Customer Name:
                <input
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
              </label>
              <label>
                Customer Mobile:
                <input
                  type="text"
                  value={customerMobile}
                  onChange={(e) => setCustomerMobile(e.target.value)}
                />
              </label>
              <label>
                Customer Email:
                <input
                  type="email"
                  value={customerEmail}
                  onChange={(e) => setCustomerEmail(e.target.value)}
                />
              </label>

              <div className="modal-footer">
                <button className="cancel-btn" onClick={closeEmailModal}>
                  Cancel
                </button>
                <button className="send-btn" onClick={handleEmailSubmit}>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{isWhatsappModalOpen && (
        <div className="modal-overlayy" onClick={closeWhatsappModal}>
          <div
            className="modal-contentt"
            style={{ backgroundColor: "white" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-headerr">
              <h4>Enter WhatsApp Number</h4>
              <button className="close-btn" onClick={closeWhatsappModal}>
                X
              </button>
            </div>
            <div className="modal-bodyy">
              <label>
                Customer Name:
                <input
                  type="text"
                  value={customerWName}
                  onChange={(e) => setCustomerWName(e.target.value)}
                />
              </label>
              <label>
                WhatsApp Number:
                <input
                  type="text"
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
          
                />
              </label>

              <div className="modal-footer">
                <button className="cancel-btn" onClick={closeWhatsappModal}>
                  Cancel
                </button>
                <button className="send-btn" onClick={handleWhatsappSubmit}>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
